/**
 * HESAP SİLİNİRKEN HAREKETLER (kullanıcı kararı 12.10.2026): "hareketleri de
 * sil" (VARSAYILAN) ya da "başka bir hesaba taşı". Taşınan hareket baştan
 * beri o hesaptaymış gibi sayılır. Hesap silme penceresi ve öksüz hareket
 * uyarısı aynı seçiciyi kullanır.
 */

import type { Account, HesapHareketSecimi } from "@parafon/contracts/local-api";
import { M } from "../dil";
import { Field, Select } from "../ui/primitives";

export interface HareketSecimiDurumu {
  readonly tur: "sil" | "tasi";
  /** "tasi"da seçilen hedef; boşsa seçim eksik. */
  readonly hedef: string;
}

export const VARSAYILAN_SECIM: HareketSecimiDurumu = { tur: "sil", hedef: "" };

/** Gönderilecek seçim; taşımada hedef seçilmediyse null (düğme kapalı kalır). */
export function secimDegeri(d: HareketSecimiDurumu): HesapHareketSecimi | null {
  if (d.tur === "sil") return { tur: "sil" };
  return d.hedef === "" ? null : { tur: "tasi", hedefHesapId: d.hedef };
}

export function HareketSecimi({
  hareketSayisi,
  hedefler,
  deger,
  onChange,
  idOnek,
}: {
  readonly hareketSayisi: number;
  /** Taşınabilecek CANLI hesaplar (silinen hesap hariç). */
  readonly hedefler: readonly Account[];
  readonly deger: HareketSecimiDurumu;
  readonly onChange: (d: HareketSecimiDurumu) => void;
  readonly idOnek: string;
}) {
  return (
    <fieldset className="mt-3 space-y-2">
      <legend className="text-[13px] font-semibold text-ink">
        {M.hareketler.secim.soru(hareketSayisi)}
      </legend>
      <label className="flex items-start gap-2">
        <input
          type="radio"
          name={`${idOnek}-tur`}
          checked={deger.tur === "sil"}
          onChange={() => onChange({ ...deger, tur: "sil" })}
        />
        <span>{M.hareketler.secim.sil}</span>
      </label>
      <label className="flex items-start gap-2">
        <input
          type="radio"
          name={`${idOnek}-tur`}
          checked={deger.tur === "tasi"}
          disabled={hedefler.length === 0}
          onChange={() => onChange({ ...deger, tur: "tasi" })}
        />
        <span>
          {M.hareketler.secim.tasi}
          {hedefler.length === 0 && <span className="block text-[12px] text-faint">{M.hareketler.secim.hedefYok}</span>}
        </span>
      </label>
      {deger.tur === "tasi" && (
        <Field label={M.hareketler.secim.hedef} htmlFor={`${idOnek}-hedef`}>
          <Select
            id={`${idOnek}-hedef`}
            value={deger.hedef}
            placeholder={M.hareketler.secim.hesapSecin}
            options={hedefler.map((a) => ({ value: a.id, label: `${a.name} (${a.currency})` }))}
            onChange={(e) => onChange({ ...deger, hedef: e.currentTarget.value })}
          />
        </Field>
      )}
    </fieldset>
  );
}
